"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCommentAlt(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M22.213 1a1.79 1.79 0 011.781 1.641l.006.146v13.277a1.79 1.79 0 01-1.641 1.781l-.146.006H9.304L5.449 22.67c-.43.537-1.274.275-1.357-.373l-.007-.106v-4.34H1.787a1.79 1.79 0 01-1.781-1.64L0 16.063V2.787a1.79 1.79 0 011.641-1.781L1.787 1h20.426zm0 1.532H1.787a.26.26 0 00-.248.197l-.007.058v13.277a.26.26 0 00.197.248l.058.007h3.064c.388 0 .708.288.759.662l.007.104v2.922l2.721-3.4.012-.015a.77.77 0 01.057-.06l-.069.075a.77.77 0 01.494-.28l.026-.004a.77.77 0 01.07-.004H22.213a.26.26 0 00.248-.197l.007-.058V2.787a.26.26 0 00-.197-.248l-.058-.007z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgCommentAlt;
exports.default = _default;